var map = {
	"./app.png": 3685,
	"./contact.png": 4568,
	"./invoice.png": 5513,
	"./order.png": 8328,
	"./page.png": 6351,
	"./payment.png": 1634,
	"./subscription.png": 3525
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7395;